// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__wJSbk","title":"Footer_title__LzAGn","description":"Footer_description__Uo+We","footerlink":"Footer_footerlink__GYwPI"};